import React, { useEffect, useState } from "react";
import Footer from "../Header/Footer";
import Header from "../Header/Header";
import { FaEye, FaEyeSlash, FaShoppingCart, FaTrashAlt } from "react-icons/fa";
import Config from "../Header/Config";
import { ToastContainer, toast } from 'react-toastify';
import { useLocation, useNavigate } from "react-router-dom";

export default function Expense_update() {
  const apiUrl = Config.apiUrl;
  const [expense_name, setExpenseName] = useState("");
  const [expense_details, setExpenseDetails] = useState("");
  const [date, setDate] = useState("");
  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState("");


  const navigate = useNavigate();

  const capitalizeWords = (str) => {
    if (!str) return '';
    return str
      .toString()
      .split(/\s+/)
      .map((w) => (w.length > 0 ? w[0].toUpperCase() + w.slice(1).toLowerCase() : ''))
      .join(' ');
  };

  //........................................

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (id) {
          const response = await fetch(`${apiUrl}/get_allExpenseList`);
          const data = await response.json();
          const item = Array.isArray(data.data) ? data.data.find(i => String(i.id) === String(id)) : null;
          if (item) {
            setExpenseName(item.expense_name || '');
            setExpenseDetails(item.expense_details || '');
            setDate(item.date || '');
            setAmount(item.amount || '');
            setDescription(item.description || '');
          }
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [id]);

  //.............................................................

  const updateExpense = async () => {
    const item = {
      expense_name,
      expense_details,
      date,
      amount,
      description,
    };

    try {
      const result = await fetch(`${apiUrl}/update_expenseEntry/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(item),
      });

      if (result.ok) {
        toast.success('Expense updated successfully');
        navigate('/ExpensesList');
      } else {
        toast.error('Failed to update Expense');
      }
    } catch (error) {
      console.error(error);
      toast.error('Failed to update Expense');
    }
  };


  return (
    <>
      <ToastContainer />
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <h4 className="fw-bold py-3 mb-4">Expense Details (Edit)</h4>

                <div className="card mb-4">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="mb-0 heading-heighlight">Edit Expense</h5>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Expense Name</label>
                        <input className="form-control" value={expense_name} onChange={(e)=>{
                          const v = capitalizeWords(e.target.value);
                          setExpenseName(v);
                        }} />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Expense Details</label>
                        <input className="form-control" value={expense_details} onChange={(e)=>{
                          const v = capitalizeWords(e.target.value);
                          setExpenseDetails(v);
                        }} />
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="form-label">Date</label>
                        <input type="date" className="form-control" value={date} onChange={(e)=>setDate(e.target.value)} />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Amount</label>
                        <input className="form-control" value={amount} onChange={(e)=>setAmount(e.target.value)} />
                      </div>

                      <div className="col-12 mb-3">
                        <label className="form-label">Description</label>
                        <textarea className="form-control" rows={3} value={description} onChange={(e)=>setDescription(e.target.value)} />
                      </div>

                      <div className="col-12 d-flex justify-content-end">
                        <button type="submit" className="btn btn-primary" style={{ marginLeft: "5px", marginRight: "5px" }} onClick={() => updateExpense()}>
                          Update
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Footer />

              <div className="content-backdrop fade" />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle" />
      </div>
    </>
  );
}
